// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__UI691","nav__list":"Navigation_nav__list__rzlrP","mobile":"Navigation_mobile__lHlI0"};